import { post } from 'services/ajax';

const CONNECT_AUTH_ROOT = `${process.env.API_URL}/resource/v1`;

export interface AuthenticationUserPayloadI {
  email: string;
  loggedIn: boolean;
  modelType: 'User';
  given_name: string;
  family_name: string;
  sub: string;
  id_token: string;
}

export async function connectAuthentication(code: string, nonce: string): Promise<AuthenticationUserPayloadI> {
  const raw = await post(`${CONNECT_AUTH_ROOT}/authenticate`, {
    code,
    nonce,
    redirectUrl: `${window.location.origin}/`,
  });

  return raw;
}
